import { combineReducers } from 'redux';
import formReducer from './formReducer';
import listReducer from './listReducer';
import baseReducer from './baseReducer';

const reducer = combineReducers({
  base: baseReducer,
  form: formReducer,
  list: listReducer,
});

export default reducer;
